module.exports = __webpack_public_path__ + "static/ArchicadIcon-a0cd422a5ed529ee1daa6be8c3ab3fe7.png";